export default "__VITE_ASSET__BuJ$iTkz__"